import { render, staticRenderFns } from "./RejectedUser.vue?vue&type=template&id=5f53b380&scoped=true&"
import script from "./RejectedUser.vue?vue&type=script&lang=js&"
export * from "./RejectedUser.vue?vue&type=script&lang=js&"
import style0 from "./RejectedUser.vue?vue&type=style&index=0&id=5f53b380&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f53b380",
  null
  
)

export default component.exports